<template>
	<div class="sharetybox ">
		
		<div class="bullehead FlexBetween">
			<div class="head_left "  :class="{'style2': types == 2}">
				<div class="head_title">
					{{title || ''}}
				</div>
			</div>
			<div class="head_right FlexRow">
				<div class="h_span" v-for="(item, index) in navlist">
					{{item}}
				</div>
			</div>
		</div>
		
		
		<div class="share_body">
			<div class="share_line Flexalign" v-for="(item, index) in share_list">
				<div class="line_left Flexalign" :class="{'style2': types == 2}">
					<div class="share_icon FlexRow">
						<img :src="urlhead + item.icon" alt="">
					</div>
					<div class="share_tit">
						{{item.title}}
					</div>
				</div>
				<div class="line_right FlexRow" v-if="types == 1">
					<div class="share_num">
						{{item.link_num}}
					</div>
					<div class="share_num">
						{{item.poster_num}}
					</div>
				</div>
				<div class="line_right FlexRow" v-else-if="types == 2">
					<div class="share_num">
						{{item.card_num}}
					</div>
					<div class="share_num">
						{{item.goods_num}}
					</div>
					<div class="share_num">
						{{item.article_num}}
					</div>
				</div>
			</div>
		</div>
		
	</div>
</template>

<script>
	import {
		fn_overload,
	} from "../js/billet.js"
	export default {
		name: 'sharetybox',
		props: {
			types: {
				type: Number,
				default: 1,
			},
			dataobj: {
				type: Object,
				default: ()=>{
					return {}
				},
			},
		},
		data(){
			return {
				navlist: [],
				title: '分享方式',
				
				share_list: [],
				urlhead: 'https://scrm.51kuaiding.com/scrm/hktxcx/bulletinboard',
				
				
			}
		},
		watch: {
			dataobj(){
				this.fn_SetDatas()
			},
		},
		methods: {
			fn_SetDatas(){
				if(this.dataobj) {
					if(this.types == 1) {
						this.share_list = [
							{
								icon: '/share1-1.png', 
								title: '分享次数',
								link_num: fn_overload(this.dataobj.link_forward),
								poster_num: fn_overload(this.dataobj.poster_forward),
							},
							{
								icon: '/share1-2.png',
								title: '浏览次数',
								link_num: fn_overload(this.dataobj.link_visit),
								poster_num: fn_overload(this.dataobj.poster_visit),
							},
							{
								icon: '/share1-3.png',
								title: '获取线索',
								link_num: fn_overload(this.dataobj.link_cuepool),
								poster_num: fn_overload(this.dataobj.poster_cuepool),
							},
							{
								icon: '/share1-4.png',
								title: '意向客户',
								link_num: fn_overload(this.dataobj.link_customer),
								poster_num: fn_overload(this.dataobj.poster_customer),
							},
						]
					}
					else if(this.types == 2) {
						this.share_list = [
							{
								icon: '/share1-1.png',
								title: '分享次数',
								card_num: fn_overload(this.dataobj.card_forward),
								goods_num: fn_overload(this.dataobj.goods_forward),
								article_num: fn_overload(this.dataobj.article_forward),
							},
							{
								icon: '/share1-2.png',
								title: '浏览次数',
								card_num: fn_overload(this.dataobj.card_visit),
								goods_num: fn_overload(this.dataobj.goods_visit),
								article_num: fn_overload(this.dataobj.article_visit),
							},
							{
								icon: '/share1-3.png',
								title: '线索数量',
								card_num: fn_overload(this.dataobj.card_cuepool),
								goods_num: fn_overload(this.dataobj.goods_cuepool),
								article_num: fn_overload(this.dataobj.article_cuepool),
							},
							{
								icon: '/share1-4.png',
								title: '意向客户',
								card_num: fn_overload(this.dataobj.card_customer),
								goods_num: fn_overload(this.dataobj.goods_customer),
								article_num: fn_overload(this.dataobj.article_customer),
							},
						]
					}
				}
			},
		},
		created(){
			if(this.types == 1) {
				this.navlist = [
					'链接分享', '海报分享'
				]
				this.title = '分享方式'
				
			}
			else if(this.types == 2) {
				this.navlist = [
					'分享名片', '分享产品', '分享文章'
				]
				this.title = '分享内容'
				
				
			}
		
		},
	}
</script>

<style lang="scss" scoped>
	@import "../css/billet.scss";
	.sharetybox{
		width: 100%;
		min-width: 600px;
	}
	.head_left{
		width: 330px;
	}
	.head_left.style2{
		width: 265px;
	}
	.head_right{
		flex: 1;
		.h_span{
			white-space: nowrap;
			flex: 1;
			font-size: 14px;
			font-weight: 400;
			letter-spacing: 0px;
			line-height: 0px;
			color: rgba(51, 51, 51, 1);
			text-align: left;
		}
	}
	.share_body{
		padding: 0 30px;
		.share_line:last-of-type{
			border-bottom: none;
		}
		.share_line{
			min-height: 72px;
			border-bottom:solid 1px rgba(243, 243, 243, 1);
			.line_left.style2{
				width: 265px;
			}
			.line_left{
				width: 330px;
				.share_icon{
					width: 32px;
					height: 32px;
					border-radius: 100%;
					margin-right: 14px;
					overflow: hidden;
					background: rgba(228, 237, 252, 1);
					img{
						width: 100%;
						height: 100%;
					}
				}
				.share_tit{
					font-size: 14px;
					font-weight: 400;
					letter-spacing: 0px;
					line-height: 0px;
					color: rgba(96, 98, 102, 1);
				}
			}
			.line_right{
				flex: 1;
				.share_num{
					flex: 1;
					font-size: 22px;
					font-weight: 500;
					letter-spacing: 0px;
					line-height: 0px;
					color: rgba(43, 117, 235, 1);
				}
			}
		}
	}
	
	

</style>